import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import {
  CheckBill,
  type CheckBillSuccessPayload,
  IdentificationMode,
} from "../components/CheckBill/CheckBill";
import { GasInvoicePaymentFrame } from "./GasInvoicePayment";

export function PreBillPayment() {
  const [mode, setMode] = useState<IdentificationMode>("gas_account");
  const [verification, setVerification] = useState<
    CheckBillSuccessPayload | undefined
  >(undefined);

  useEffect(() => {
    setVerification(undefined);
  }, [mode]);

  return (
    <Box>
      {!verification && (
        <Paper
          sx={{
            p: 3,
            pb: 0,
            borderRadius: 3,
            maxWidth: 1280,
            mx: "auto",
            textAlign: "right",
          }}
          elevation={0}
        >
          <Typography fontWeight={800} fontSize={26} sx={{ textAlign: "left" }}>
            תשלום חשבון גז
          </Typography>

          <Typography
            fontWeight={800}
            fontSize={19}
            sx={{ mb: 0, textAlign: "left" }}
          >
            על פי מה לזהות אותך:
          </Typography>

          <RadioGroup
            row
            value={mode}
            onChange={(e) => setMode(e.target.value as IdentificationMode)}
            sx={{
              gap: 3,
              "& .MuiFormControlLabel-label": {
                fontSize: 20,
                fontWeight: 800,
              },
            }}
          >
            <FormControlLabel
              value="gas_account"
              control={<Radio />}
              label="פרטי חשבון גז"
            />
            <FormControlLabel
              value="gas_account_id"
              control={<Radio />}
              label="ת.ז ומספר צרכן"
            />
            <FormControlLabel
              value="id_mobile"
              control={<Radio />}
              label="טלפון ומס' צרכן"
            />
          </RadioGroup>
        </Paper>
      )}

      {!verification && (
        <CheckBill mode={mode} onSuccess={(payload) => setVerification(payload)} />
      )}

      {verification && (
        <GasInvoicePaymentFrame
          logisticNumber={verification.customerCode}
          identificationType={verification.identificationType}
          identificationValue={verification.identificationValue}
          firmCode={verification.firmCode}
        />
      )}
    </Box>
  );
}
